module.exports = __webpack_public_path__ + "static/media/ekstrakulikuler.bf6dd860.png";